import { useState } from "react";
import SvgLeft2 from "../Svg/SvgLeft2";
import SvgInfos4 from "../Svg/SvgInfos4";

export default function Home() {
    // voir photo + nom
  const [seePhotoWithName, setSeePhotoWithName] = useState(false);
  async function SeePhotoWithName() {
    setSeePhotoWithName(true);
  }
  async function CloseSeePhotoWithName() { //fermer
    setSeePhotoWithName(false);
  }

  //moreInfos - Dans ce card on affiche plus d'infos sur l'artiste
  const [moreInfos, setMoreInfos] = useState(false);
  async function MoreInfos() {
    setMoreInfos(true);
  }
  async function CloseMoreInfos() { //fermer
    setMoreInfos(false);
  }

  const ashnaPhoto = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724811408/rasivy-page01/jhgkayhmxc0zqtbmqwx5.jpg";
  
  const anghamiLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724822648/rasivy-page01/xmmgafaugkodkgsaxhza.jpg";
  const audiomackLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724358883/rasivy-page01/atfzjquu2b8ss5sxxsjx.jpg";
  const appleLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724705761/rasivy-page01/c5yp78gnhqx7woregiu3.jpg";
  const boomplayLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724358883/rasivy-page01/smi8kxat4nmj3zgeuwup.jpg";
  const deezerLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724822648/rasivy-page01/bz97scr2wpqzueo1gj6b.jpg";
  const facebookLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724242915/rasivy-page01/lbdvu40lrzvvcdnm3ndt.jpg";
  const instagramLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724242915/rasivy-page01/o5nupt3klev3nhcelzn7.jpg";
  const spotifyLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724242915/rasivy-page01/esewkyhpmpjvcizuu5o8.jpg";
  const tiktokLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724242915/rasivy-page01/yufzyhooxudshtnnb2zh.jpg";
  const tidalLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724822647/rasivy-page01/ezxmmx2ukltrntnebiya.jpg";
  const xLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724822647/rasivy-page01/wtfq0pfgctjilu94ri8o.jpg";
  const youtubeLogo = "https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724270010/rasivy-page01/b9b1gazizab4xb7fjdlh.jpg";
  
  const rdcFlag ="https://res.cloudinary.com/dzjhdpsxs/image/upload/v1724704394/rasivy-page01/vdwtarksiywp8gna7gew.jpg";

  return (
    <>
      <div className="background">
        <div className="photo-and-name">
          <div className="photo" onClick={SeePhotoWithName}> <img src={ashnaPhoto} alt="Ashna Lweri"/> </div>

          <div className="name">
            <div className="a"> <p>Ashna Lweri</p> </div>
            <div className="b"> <p>Suivez-moi sur</p> </div>
          </div>
          {/* name */}
        </div>
        {/* photo-and-name */}

        <div className="platform">
          <div className="width">

            {/* Audiomack */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://audiomack.com/ashna-lweri" target="_blank" rel="noopener noreferrer"> 
                    <img src={audiomackLogo} alt="Logo de Audiomack" />
                    <p>Audiomack</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://audiomack.com/ashna-lweri" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Anghami */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://play.anghami.com/artist/19743966" target="_blank" rel="noopener noreferrer"> 
                    <img src={anghamiLogo} alt="Logo de Anghami" />
                    <p>Anghami</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://play.anghami.com/artist/19743966" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Apple Music */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://music.apple.com/fr/artist/ashna-lweri/1722922509" target="_blank" rel="noopener noreferrer"> 
                    <img src={appleLogo} alt="Logo de Apple" />
                    <p>Apple Music</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://music.apple.com/fr/artist/ashna-lweri/1722922509" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Boomplay */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.boomplay.com/artists/82379996?from=search&srModel=COPYLINK&srList=WEB" target="_blank" rel="noopener noreferrer"> 
                    <img src={boomplayLogo} alt="Logo de Boomplay" />
                    <p>Boomplay</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.boomplay.com/artists/82379996?from=search&srModel=COPYLINK&srList=WEB" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Deezer */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.deezer.com/fr/artist/248239322?host=0&utm_campaign=clipboard-generic&utm_source=user_sharing&utm_content=artist-248239322&deferredFl=1" target="_blank" rel="noopener noreferrer"> 
                    <img src={deezerLogo} alt="Logo de Boomplay" />
                    <p>Deezer</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.deezer.com/fr/artist/248239322?host=0&utm_campaign=clipboard-generic&utm_source=user_sharing&utm_content=artist-248239322&deferredFl=1" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Facebook */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.facebook.com/ashnalweri" target="_blank" rel="noopener noreferrer"> 
                    <img src={facebookLogo} alt="Logo de Facebook" />
                    <p>Facebook</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.facebook.com/ashnalweri" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr /> 

            {/* Instagram */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.instagram.com/ashnalweri" target="_blank" rel="noopener noreferrer"> 
                    <img src={instagramLogo} alt="Logo de Instagram" />
                    <p>Instagram</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.instagram.com/ashnalweri" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr /> 

            {/* Spotify */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://open.spotify.com/intl-fr/artist/7FVs6ugqzS88Fd6xNc2n3K?si=3tbvgJs9STayvbGk9IhXSQ&nd=1&dlsi=a5c416459e2746a2" target="_blank" rel="noopener noreferrer"> 
                    <img src={spotifyLogo} alt="Logo de Spotify" />
                    <p>Spotify</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://open.spotify.com/intl-fr/artist/7FVs6ugqzS88Fd6xNc2n3K?si=3tbvgJs9STayvbGk9IhXSQ&nd=1&dlsi=a5c416459e2746a2" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

            {/* Tik Tok */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.tiktok.com/@ashnalweri" target="_blank" rel="noopener noreferrer"> 
                    <img src={tiktokLogo} alt="Logo de Tik Tok" />
                    <p>Tik Tok</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.tiktok.com/@ashnalweri" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr /> 

            {/* Tidal */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://tidal.com/browse/artist/44671415" target="_blank" rel="noopener noreferrer"> 
                    <img src={tidalLogo} alt="Logo de Tidal" />
                    <p>Tidal</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://tidal.com/browse/artist/44671415" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr /> 

            {/* X */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://x.com/Ashnalweri" target="_blank" rel="noopener noreferrer"> 
                    <img src={xLogo} alt="Logo de X" />
                    <p>Twitter</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://x.com/Ashnalweri" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr /> 

            {/* youtube */}
            <div className="logo-and-button">
              <div className="logo"> 
                <a href="https://www.youtube.com/channel/UC7VB_-u0VOalUZQ1Ezf6xQw" target="_blank" rel="noopener noreferrer"> 
                    <img src={youtubeLogo} alt="Logo de Youtube" />
                    <p>Youtube</p> 
                </a> 
              </div>

              <div className="button"> <a href="https://www.youtube.com/channel/UC7VB_-u0VOalUZQ1Ezf6xQw" target="_blank" rel="noopener noreferrer"><button>Suivre</button></a>  </div>
            </div>
            {/* logo-and-button */}
            <hr />

          </div>
          {/* width */}
        </div>
        {/* platform */}

        <div className="name-of-label"> <p>Copyright by ASM-Transformation-CD</p> </div>
        {/* name-of-label */}

        <div className="created">
          <div className="a"> <a href="https://rasivy.vercel.app" target="_blank" rel="noopener noreferrer"><p>Créer par</p> </a> </div>
          <div className="b"> <a href="https://rasivy.vercel.app" target="_blank" rel="noopener noreferrer"><p>rasivy</p> </a> </div>
        </div>
        {/* created */}
      </div>
      {/* background */}


      {/* voir photo + nom */}
      {/* voir photo + nom */}
      {seePhotoWithName && (<>
          <div className="seePhotoWithName">
            <div className="close">
              <div onClick={CloseSeePhotoWithName} className="a"> <SvgLeft2 /> </div>
              <div onClick={MoreInfos} className="b"> <SvgInfos4 /> </div>
            </div>
            {/* close */}

            <div className="card">
              <div className="a">
                <div className="aa"> <img src={ashnaPhoto} alt="Ashna Lweri" /> </div>
                <div className="bb"> <p>Ashna Lweri</p> </div>
              </div>
              {/* a */}

              <div className="b"> </div>
              {/* b */}
            </div>
            {/* card */}
          </div>
          {/* seePhotoWithName */}
        </>
      )}
      {/* voir photo + nom */}


      {/* moreInfos - Dans ce card on affiche plus d'infos sur l'artiste */}
      {/* moreInfos - Dans ce card on affiche plus d'infos sur l'artiste */}
      {moreInfos && (<>
      <div onClick={CloseMoreInfos} className="moreInfos">
        <div className="align">
          <div className="card">
            <div className="a"> <p>Ashna Lweri est une artiste musiciennne de nationalité congolaise.</p> </div>

            <div className="b"> 
              <img src={rdcFlag} alt="Drapeau de la RDC" />
              <p>RDC</p> 
            </div>
          </div>
          {/* card */}
        </div>
        {/* align */}
      </div>
      {/* moreInfos */}
      </>)}
      {/* moreInfos - Dans ce card on affiche plus d'infos sur l'artiste */}

    </>
  );
}
